import React from 'react';

const TotalizaResultados = ({ totales, totalPorAtender, totalAtendidos, totalDia }) => {
  return (
    <div className='flex flex-col w-full mb-4 items-center justify-center'>
       <div className="mt-2 rounded-lg border border-stone-200 w-[80%] overflow-x-auto">
          <table className="w-full table-auto">
            <thead className="border-b border-stone-200 text-sm font-medium">
              <tr>
                <th className="px-2.5 py-2 text-start font-medium">Nombre de Servicio</th>
                <th className="px-2.5 py-2 text-start font-medium">Por Atender</th>
                <th className="px-2.5 py-2 text-start font-medium">Atendidos</th>
                <th className="px-2.5 py-2 text-start font-medium">Total del Periodo</th>
             </tr>
           </thead>
           <tbody className="group text-sm text-stone-800 ">
               {Object.entries(totales).map(([NombreServ, total]) => (
                   <tr key={NombreServ}>
                       <td>{NombreServ}</td>
                       <td>{total['Por Atender']}</td>
                       <td>{total['Atendidos']}</td>
                       <td>{total['Por Atender'] + total['Atendidos']}</td>
                   </tr>
                ))}
           </tbody>
           <tfoot>
              <tr>
                <td>Total General</td>
                <td>{totalPorAtender}</td>
                <td>{totalAtendidos}</td>
                <td>{totalDia}</td>
             </tr>
           </tfoot>
         </table>
       </div> 
    </div>         
 );
};

export default TotalizaResultados;
